import React, { Component } from "react";

class Testimonial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      testimonial: [
        {
          id: 1,
          text: '" I have been buying building materials from K.LIZZ Classic Hardware for over 5 years. Their plywood quality is exceptional and the prices are very competitive. The staff is knowledgeable and always helps me choose the right materials for my projects. Highly recommended! "',
          name: "JOHN MWANGI - Contractor",
        },
        {
          id: 2,
          text: '" K.LIZZ Classic Hardware is my go-to supplier for all furniture-making materials. Their MDF boards and veneers are top quality, and they always have stock available. The lipping service is excellent and saves me a lot of time. Fair prices and great customer service! "',
          name: "MARY WANJIKU - Furniture Maker",
        },
        {
          id: 3,
          text: '" As a professional carpenter, I need reliable suppliers. K.LIZZ Classic Hardware delivers every time - quality block boards, comprehensive hardware selection, and competitive bulk pricing. They truly flow with qualities as their tagline says. My projects run smoothly because of their service. "',
          name: "DAVID OTIENO - Professional Carpenter",
        },
        {
          id: 4,
          text: '" Best hardware store in Nairobi! I bought all materials for my home renovation from K.LIZZ - plywood, paints, tools, cement, everything. The staff took time to explain which products were best for my needs. Great quality products from trusted brands like Cona, Seweco, and Blue Triangle. "',
          name: "GRACE AKINYI - Homeowner",
        },
        {
          id: 5,
          text: '" K.LIZZ Classic Hardware has been our main supplier for the past 3 years. Their marine boards and veneer ply are excellent quality, perfect for our custom cabinetry business. Quick service, good prices, and they deliver on time. A reliable partner for our business growth. "',
          name: "PETER KAMAU - Cabinet Maker",
        },
      ],
    };
  }

  render() {
    return (
      <div
        className="row-testimonials parallax-2"
        style={{ backgroundColor: "#8B1A1A" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div
                className="themesflat-spacer clearfix"
                data-desktop={80}
                data-mobile={60}
                data-smobile={60}
              />
              <div
                className="themesflat-carousel-box has-arrows arrow-center arrow-circle offset-v-24 clearfix"
                data-gap={30}
                data-column={1}
                data-column2={1}
                data-column3={1}
                data-auto="true"
              >
                <div className="owl-carousel owl-theme">
                  {this.state.testimonial.map((data) => (
                    <div
                      className="themesflat-testimonials style-1 max-width-70 align-center has-width w100 circle border-solid clearfix"
                      key={data.id}
                      style={{ borderColor: "#FFD700" }}
                    >
                      <div className="testimonial-item">
                        <div className="inner">
                          <div
                            className="icon-wrap"
                            style={{ color: "#FFD700" }}
                          >
                            <i className="fa fa-quote-left" />
                          </div>
                          <blockquote className="text">
                            <p style={{ color: "#FFD700" }}>{data.text}</p>
                            <div
                              className="sep has-width w80 clearfix"
                              style={{ backgroundColor: "#FFD700" }}
                            />
                            <h6 className="name" style={{ color: "#FFD700" }}>
                              {data.name}
                            </h6>
                          </blockquote>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div
                className="themesflat-spacer clearfix"
                data-desktop={68}
                data-mobile={60}
                data-smobile={60}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Testimonial;
